import { db } from "@/firebaseConfig";
const printerErrorsCollection = db.collection("printer_errors");

const savePrinterError = async data => {
  printerErrorsCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("PrinterError successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updatePrinterError = async (id, data) => {
  printerErrorsCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("PrinterError successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deletePrinterError = async id => {
  printerErrorsCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("PrinterError successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getPrinterErrorById = async id => {
  return printerErrorsCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getPrinterErrorsByDateRange = async (date1, date2) => {
  return printerErrorsCollection
    .where("time", ">=", date1)
    .where("time", "<=", date2)
    .orderBy("time", "desc")
    .get()
    .then(querySnapshot => {
      let result = [];

      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });

      return result;
    })
    .catch(error => {
      throw error;
    });
};

export {
  printerErrorsCollection,
  savePrinterError,
  updatePrinterError,
  deletePrinterError,
  getPrinterErrorById,
  getPrinterErrorsByDateRange
};
